import { gql } from '@apollo/client';

// Operation name `StudentInvoices` is deliberately distinct from the backend
// field `myInvoices` — equal operation/field names make codegen collapse the
// generated result type into the schema payload type (see graphql-codegen skill).
export const StudentInvoicesQuery = gql`
  query StudentInvoices {
    myInvoices {
      fakturowniaId
      number
      status
      issueDate
      paymentTo
      currency
      priceGross
      paid
      outstanding
      isOverdue
      daysOverdue
      viewUrl
      paymentUrl
      # ТЗ 0044: суммы выше уже НЕТТО (за вычетом корректировок). Флаг нужен,
      # чтобы объяснить студенту, почему сумма отличается от бумаги на руках.
      isCorrected
      correctionReason
      # ТЗ 0074: фактура держит приостановку доступа — выделяется и идёт первой.
      isBlocking
    }
  }
`;
